import React from 'react';
import { useTranslation } from 'react-i18next';
import { Save, Loader2 } from 'lucide-react';

export default function FloatingSaveButton({ onSave, saving, hasUnsavedChanges, show }) {
  const { t } = useTranslation();

  if (!show || !hasUnsavedChanges) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button
        onClick={onSave}
        disabled={saving}
        className={`
          inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-full
          shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
          transition-all duration-200 transform hover:scale-105 backdrop-blur-sm
          ${saving 
            ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
            : 'bg-blue-600 text-white hover:bg-blue-700 active:scale-95 shadow-blue-200'
          }
        `}
      >
        {saving ? (
          <>
            <Loader2 className="animate-spin mr-2 h-4 w-4" />
            {t('settings.saving')}
          </>
        ) : (
          <>
            <Save className="mr-2 h-4 w-4" />
            {t('settings.save')}
          </>
        )}
      </button>
    </div>
  );
}
